angular
  .module('app')
  .service('Session', Session);

function Session($state, $log, $window, $rootScope) {
  this.create = function (sessionId, user) {
    this.id = sessionId;
    this.userId = user.id;
    this.email = user.email;
    this.name = user.name;
  };
  this.destroy = function () {
    this.id = null;
    this.userId = null;
    this.email = null;
    this.name = null;
  };
  this.go = function (id) {
    $state.go(id);
  };
  this.reload = function () {
    $state.reload();
  };
  this.log = function (obj) {
    $log.info(obj);
  };
  this.alert = function (obj) {
    $window.alert(obj);
  };
  this.top = function () {
    $window.scrollTo(0, 0);
  };
  this.root = function () {
    return $rootScope;
  };
  this.open = function (url) {
    $window.open(url, '_blank');
  };
  this.enableLoading = function () {
    $rootScope.progress = 'We are retreaving data, please wait...';
    $rootScope.loading = true;
  };
  this.disableLoading = function () {
    $rootScope.loading = false;
  };
  this.updateProgress = function (n) {
    if (n >= 0) {
      $rootScope.progress = n + '% uploaded. Please don\'t close the browser';
    } else {
      $rootScope.progress = 'We are validating your file. Please don\'t close the browser. It can take a few minutes.';
    }
  };
}
